import _ from 'lodash';

import {MessageAnnotationModel} from '../../../../../libs/shared/core/src/models/api/annotationModel';
import {AnnotationAnnotatedResourcesEnum} from '../../../../../libs/shared/core/src/models/api/annotationTypes';
import {MessageModel} from '../../../../../libs/shared/core/src/models/api/messageModel';
import {canSplitMessage} from '../../../../../src/helpers/models/messageHelpers';
import {ConversationModel} from '../../../../../src/models/api/conversationModel';
import {makeGetApplicationChannelTypeFromConversation} from '../../../../../src/store/data/applicationChannelTypes/applicationChannelTypesSelectors';
import {makeGetReplyChannel} from '../../../../../src/store/data/channels/channelsSelectors';
import {getAnnotations} from '../../../../../src/store/data/dataSelectors';
import {makeGetExternalChannelTypeFromConversation} from '../../../../../src/store/data/externalChannelTypes/externalChannelTypesSelectors';
import {AppParametricSelector, createSelector} from '../../../../helpers/reselectHelpers';

type GetOptionalConversation = AppParametricSelector<any, ConversationModel | undefined>;
type GetMessage = AppParametricSelector<any, MessageModel>;

export function makeGetCanSplitMessage(getConversation: GetOptionalConversation, getMessage: GetMessage) {
  return createSelector(
    [
      getMessage,
      getConversation,
      makeGetApplicationChannelTypeFromConversation(getConversation),
      makeGetExternalChannelTypeFromConversation(getConversation),
    ],
    (message, conversation, applicationChannelType, externalChannelType) =>
      (conversation && canSplitMessage(message, conversation, applicationChannelType, externalChannelType)) ||
      false,
  );
}

type GetSelectedInboxId = AppParametricSelector<any, number | undefined>;

export function makeGetShowReplyAction(getMessage: GetMessage, getSelectedInboxId: GetSelectedInboxId) {
  const getReplyChannel = makeGetReplyChannel({
    getMessage,
    getSelectedInboxId,
  });

  return createSelector([getReplyChannel], (replyChannel) => Boolean(replyChannel));
}

export function makeGetMessageAnnotations(getMessage: GetMessage) {
  return createSelector(
    [getAnnotations, getMessage],
    (annotations, message): ReadonlyArray<MessageAnnotationModel> =>
      _(annotations)
        .map(
          (a) =>
            a?.annotatedResourceType === AnnotationAnnotatedResourcesEnum.MESSAGE &&
            a?.annotatedMessageId === message.id &&
            a,
        )
        .compact()
        .value(),
  );
}
